import React from "react";
import { useState } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel3";
import { TopSearch } from "./home/TopSearch";
import ProductBox from "./home/ProductBox";
import CardItem from "./common/CardItem";
import SectionHeading from "./common/SectionHeading";
import FontAwesome from "./common/FontAwesome";
import Func from "./home/ComponentMein";
import ComponentMein from "./home/ComponentMein";
import { SearchResultsList } from "./home/SearchResultsList";
import { liefershops } from "../utils.js";
import { Helmet } from 'react-helmet';
import { getPartnerData, isPartnerDomain } from '../partnerDomain';

export function Index() {
  const [results, setResults] = useState([]);
  const partnerData = getPartnerData();
  const onPartnerDomain = isPartnerDomain() && partnerData;
  const siteName = onPartnerDomain ? partnerData.name : 'Liefershops.de';

  return (
    <>
      <Helmet>
        <title>{onPartnerDomain
          ? `${partnerData.name} - Bestellen Sie leckeres Essen online`
          : 'Bestellen Sie Essen online - schnell und lecker mit Liefershops.de in Berlin'}</title>
        <meta name="description" content={onPartnerDomain
          ? `Bestellen Sie köstliche Gerichte von ${partnerData.name}. Schnelle Lieferung direkt zu Ihnen.`
          : 'Bestellen Sie köstliche Gerichte aus den besten Restaurants in Ihrer Nähe. Schnelle Lieferung und einfache Bestellung mit Liefershops.de in Berlin'} />
        <meta name="keywords" content={onPartnerDomain
          ? `${partnerData.name}, Essen bestellen, Lieferservice, schnelle Lieferung`
          : 'Essen bestellen, online Bestellservice, Restaurant Lieferdienst, schnelle Lieferung'} />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <TopSearch setResults={setResults} />
      <section className="section pt-5 pb-5 bg-white homepage-add-section">
        <Container>
          <Container className="pt-2 pb-2">
            <h2 className="mb-2 font-weight-bold text-center">
              {onPartnerDomain ? (
                <>Lecker und einfach mit <span className="text-danger-oktalion">{partnerData.name}</span></>
              ) : (
                <>Lecker und einfach mit <span className="text-danger-oktalion">Liefershops.de</span></>
              )}
            </h2>
            <p className="mb-2 font-weight-normal text-center">
              Mit nur wenigen Klicks bestellen Sie jetzt ganz bequem online und erleben ein kulinarisches Abenteuer!
            </p>
          </Container>
          <Row>
            <Col md={6} lg={4} sm={12}>
              <ProductBox
                image="img/photo_1.png"
                imageClass="img-fluid rounded p-5"
                imageAlt="Gerichte online bestellen"
                linkUrl="#"
              />
              <h4 className="text-center">
                {onPartnerDomain ? 'Unsere Speisekarte' : 'Gerichte aus den besten Restaurants in Ihrer Nähe'}
              </h4>
            </Col>
            <Col md={6} lg={4} sm={12}>
              <ProductBox
                image="img/photo_2.png"
                imageClass="img-fluid rounded p-5"
                imageAlt="schnelle Lieferung aus Restaurant"
                linkUrl="#"
              />
              <h4 className="text-center">
                Schnelle Lieferung
              </h4>
            </Col>
            <Col md={6} lg={4} sm={12}>
              <ProductBox
                image="img/photo_3.png"
                imageClass="img-fluid rounded p-5"
                imageAlt="ein kulinarisches Abenteuer"
                linkUrl="#"
              />
              <h4 className="text-center">
                Bezahlung in bar an den Zusteller oder PayPal
              </h4>
            </Col>
          </Row>
        </Container>
      </section>

      {!onPartnerDomain && (
        <section className="your-favorite-food gap pt-5 pb-5">
          <Container>
            <Row className="row align-items-center">
              <Col lg={5}>
                <div className="food-photo-section">
                  <Image alt="professioneller Koch" src="img/photo-4.png" className="img-fluid rounded pt-3 pb-3" />
                </div>
              </Col>
              <Col lg={6}>
                <div className="food-content-section">
                  <h2>Lassen Sie uns das gemeinsam tun! Werden Sie ein Partner!</h2>
                  <p>
                    Wachsen Sie gemeinsam mit Liefershops.de! Wir helfen Ihnen, Ihren Umsatz zu steigern und neue Möglichkeiten zu erschließen!
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </>
  );
}

const options = {
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 4,
    },
    1200: {
      items: 4,
    },
  },

  lazyLoad: true,
  pagination: false.toString(),
  loop: true,
  dots: false,
  autoPlay: 2000,
  nav: true,
  navText: [
    "<i class='fa fa-chevron-left'></i>",
    "<i class='fa fa-chevron-right'></i>",
  ],
};

export default Index;
